import { render, staticRenderFns } from "./TaskPanel.vue?vue&type=template&id=466a15ae"
import script from "./TaskPanel.vue?vue&type=script&lang=js"
export * from "./TaskPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports